import { render, staticRenderFns } from "./modalDetalleRelacion.vue?vue&type=template&id=65a343d8&scoped=true&"
import script from "./modalDetalleRelacion.vue?vue&type=script&lang=js&"
export * from "./modalDetalleRelacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a343d8",
  null
  
)

export default component.exports